import {updateNoteLabel} from "../../../../services/api/labelApi"

export default async function (labelId, note) {
    const payload = {
        note,
    }

    const {data: response} = await updateNoteLabel(labelId, payload)

    const {success, error} = response

    if (!success) throw new Error(error)

    return true
}
